import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import store from './store';

import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import {
	messages
} from './components/i18n';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/icon.css';
import './components/directives';
import 'babel-polyfill';

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

Vue.use(VueI18n);
Vue.use(ElementUI, {
	size: 'small'
});
const i18n = new VueI18n({
	locale: 'zh',
	messages
});



//使用钩子函数对路由进行权限跳转，判断用户是否登陆
router.beforeEach((to, from, next) => {
	document.title = `${to.meta.title} - 工程机械管理后台`;
	let msUsername = localStorage.getItem('ms_username');
	if (to.path === '/branchmgment' && msUsername == '总部管理员' && !sessionStorage.getItem('isFirstLogin')) {
		sessionStorage.setItem('isFirstLogin', 'true');
		next('/indexEcharts');
	}
	if (to.path === '/login') {
		next();
	} else {
		let token = sessionStorage.getItem('Authorization');
		if (token === null || token === '') {
			next('/login');
		} else {
			if (organizationKind == 2) {
				if (to.path === '/') {
					var organizationKind = localStorage.getItem('organizationKind');
					var role = localStorage.getItem('role');
					if (role == 1) {
						next('/branchmgment');
					} else if (role == 2) {
						next('/licenseapplys');
					} else if (role == 3) {
						next('/licenseapplys');
					} else {
						next('/branchmgment');
					}

				} else {
					// 分支
					next('/licencerelation');
				}
			}

			// 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
			if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
				Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
					confirmButtonText: '确定'
				});
			} else {
				next();
			}
		}
	}
});

// 设置默认的请求超时时间。例如超过了20s就会告知用户当前请求超时，请刷新等
axios.defaults.timeout = 20000;

// 即设置post的请求头为application/json;charset=UTF-8
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
	config => {
		if (localStorage.getItem('Authorization')) {
			config.headers.Authorization = localStorage.getItem('Authorization');
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// 响应拦截器  这里主要就是进行了错误的统一处理和没登录或登录过期后调整登录页的一个操作
axios.interceptors.response.use(
	response => {
		// 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
		// 否则的话抛出错误
		if (response.status === 200) {
			var data = response.data;
			if (data.code == 401) {
				// 未认证
				// 避免空指针
				if (response.data.data == null || response.data.data == undefined) {
					response.data.data = {};
				}

				// 删除token
				localStorage.removeItem('Authorization');
				// router.replace('/login')
				router.replace('/login').catch(err => {
					// console.log(err)
				})
			}
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	},
	// 服务器状态码不是2开头的的情况
	// 这里可以跟你们的后台开发人员协商好统一的错误状态码    
	// 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
	// 下面列举几个常见的操作，其他需求可自行扩展
	error => {
		console.log(error.response.status)
		if (error.response.status) {
			switch (error.response.status) {
				// 401: 未登录
				// 未登录则跳转登录页面
				case 401:
					localStorage.removeItem('Authorization');
					this.$router.push('/login');
					break;

					// 403 token过期
					// 登录过期对用户进行提示
					// 清除本地token和清空vuex中token对象
					// 跳转登录页面                
				case 403:
					Toast({
						message: '登录过期，请重新登录',
						duration: 1000,
						forbidClick: true
					});
					localStorage.removeItem('Authorization');
					this.$router.push('/login');
					break;

					// 404请求不存在
				case 404:
					Toast({
						message: '网络请求不存在',
						duration: 1500,
						forbidClick: true
					});
					break;
					// 其他错误，直接抛出错误提示
				default:
					Toast({
						message: error.response.data.message,
						duration: 1500,
						forbidClick: true
					});
			}
			return Promise.reject(error.response);
		}
	}
);

new Vue({
	router,
	i18n,
	store,
	render: h => h(App)
}).$mount('#app');
